import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface Props {
    groupName: ?string;
}

export class SharedEventGroupName extends React.PureComponent<Props> {
    render() {
        const { groupName } = this.props;
        if (!groupName) return null;
        return groupName;
    }
}

const mapStateToProps = createStructuredSelector({
    groupName: makeSelectSharedEventValue('groupName')
});

export default connect(mapStateToProps)(SharedEventGroupName);
